import type { EditorInput } from "./types";
import {
  getEditorFlowSnapshot,
  getEditorResolveContext,
  getInputs,
} from "./inputsStore";
import {
  resolveChipDisplayStatusWithContext,
  type VariableRefContext,
  type VariableRefStatus,
} from "@/components/SpotflowV2/Sidebar/variableRefStatus";
import type { SecretLookupEntry } from "@/components/SpotflowV2/Sidebar/mentionSource";

function buildRefContext(editorId: string): VariableRefContext | null {
  const snapshot = getEditorFlowSnapshot(editorId);
  if (!snapshot) return null;

  const resolveContext = getEditorResolveContext(editorId);
  const secretsByQualifiedId = new Map<string, SecretLookupEntry>();
  for (const s of snapshot.secrets) {
    secretsByQualifiedId.set(`${s.scope}:${s.id}`, s);
  }
  return {
    nodeId: snapshot.nodeId,
    nodeDataMap: snapshot.nodeDataMap,
    edges: snapshot.edges,
    nodeRegistry: snapshot.nodeRegistry,
    dynamicNodeConfigs: snapshot.dynamicNodeConfigs,
    secretsByQualifiedId,
    variableBindings:
      resolveContext?.variableBindings ?? snapshot.variableBindings,
  };
}

export function resolveChipDisplayStatus(
  inputId: string,
  _reachableInput: EditorInput | undefined,
  editorId: string
): VariableRefStatus {
  const ctx = buildRefContext(editorId);
  return resolveChipDisplayStatusWithContext(inputId, getInputs(editorId), ctx);
}
